import React, { useState } from 'react';
import type { Badge, DigitalPassport } from '@/types/achievement';
import SummaryCards from './SummaryCards';
import RecentBadges from './RecentBadges';
import DigitalPassportsOverview from './DigitalPassportsOverview';
import BadgeDetailsPopup from './BadgeDetailsPopup';
import BadgeSharePopup from './BadgeSharePopup';
import SlideUpCard from '.././SlideUpCard';
import PassportCard from './PassportCard';

interface OverviewTabProps {
  setActiveTab: (tab: string) => void;
}

const OverviewTab: React.FC<OverviewTabProps> = ({ setActiveTab }) => {
  const [selectedBadge, setSelectedBadge] = useState<Badge | null>(null);
  const [selectedPassport, setSelectedPassport] = useState<DigitalPassport | null>(null);
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const [isCardOpen, setIsCardOpen] = useState(false);
  const [isShareOpen, setIsShareOpen] = useState(false);

  const handlePassportClick = (passport: DigitalPassport) => {
    setSelectedPassport(passport);
    setIsCardOpen(true);
  };

  const handleCloseCard = () => {
    setIsCardOpen(false);
    setSelectedPassport(null);
  };

  const handleBadgeClick = (badge: Badge) => {
    setSelectedBadge(badge);
    setIsDetailsOpen(true);
  };

  const handleShareClick = (badge: Badge) => {
    setSelectedBadge(badge);
    setIsDetailsOpen(false);
    setIsShareOpen(true);
  };

  const handleCloseDetails = () => {
    setIsDetailsOpen(false);
    setSelectedBadge(null);
  };

  const handleCloseShare = () => {
    setIsShareOpen(false);
    setSelectedBadge(null);
  };

  return (
    <>
      <SummaryCards 
        setActiveTab={setActiveTab} 
      />
      <RecentBadges 
        setActiveTab={setActiveTab} 
        onBadgeClick={handleBadgeClick} 
      />
      <DigitalPassportsOverview 
        setActiveTab={setActiveTab}
        onPassportClick={handlePassportClick}
        showAll={false}
      />

      {/* Badge Details Popup */}
      <BadgeDetailsPopup
        badge={selectedBadge}
        isOpen={isDetailsOpen}
        onClose={handleCloseDetails}
        // onShare={handleShareClick}
      />

      {/* Badge Share Popup */}
      <BadgeSharePopup
        badge={selectedBadge}
        isOpen={isShareOpen}
        onClose={handleCloseShare}
      />

      {/* Slide Up Card for Passport Details */}
      <SlideUpCard 
        isOpen={isCardOpen}
        onClose={handleCloseCard}
        title={selectedPassport?.role}
      >
        {selectedPassport && (
          <PassportCard passport={selectedPassport} />
        )}
      </SlideUpCard>
    </>
  );
};

export default OverviewTab;